'use client'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { ProductPromotion } from '@/types/product-detail'
import Image from 'next/image'
import Link from 'next/link'

type Props = {
  product: ProductPromotion
}

export const ProductPromotionItem = ({ product }: Props) => {
  const discountPercent =
    product.compare_price > product.regular_price
      ? Math.round(
          ((product.compare_price - product.regular_price) /
            product.compare_price) *
            100
        )
      : product.regular_price === 0
        ? 100
        : 0

  return (
    <Link
      href={`/product/${product.seo_alias}`}
      className='group flex h-full w-[160px] flex-col overflow-hidden rounded border border-neutral-200 bg-white'
    >
      <div className='relative h-[160px] w-[160px] shrink-0 bg-neutral-100'>
        <Image
          src={ImageHelper.getImageUrl(product.images[0]?.src, 'xs')}
          alt={product.title}
          className='h-full w-full object-cover transition-transform duration-300 group-hover:scale-105'
          width={160}
          height={160}
        />
        {discountPercent > 0 && (
          <div className='absolute left-0 top-0 bg-[#E00702] px-1.5 py-0.5 text-xs font-medium text-white'>
            -{discountPercent}%
          </div>
        )}
      </div>
      <div className='flex flex-1 flex-col gap-1 p-2.5'>
        <h4 className='line-clamp-2 font-sans text-xs font-normal text-neutral-800 group-hover:underline'>
          {product.title}
        </h4>
        {product.description && (
          <div className='text-xs font-medium text-[#273BCD]'>
            {product.description}
          </div>
        )}
      </div>
    </Link>
  )
}
